// extracted by mini-css-extract-plugin
export var growableInput = "_9g-0";
export var tagContainer = "_9g-2";
export var textInput = "_9g-1";